export { default, getServerSideProps } from "pages/[lang]/wellness";
